import { fetchAuthSession } from "aws-amplify/auth";
import { post, put, del } from "aws-amplify/api";
import { useMutation, useQueryClient } from "react-query";
import {
  FOOD_JOURNAL_LATEST_QUERY_KEY,
  FOOD_JOURNAL_QUERY_KEY,
} from "./useFoodJournalQuery";

export const useFoodJournalPostMutation = (patientUserId) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (formInputs) => {
      const session = await fetchAuthSession();
      const { body } = await post({
        apiName: "hifoodjournalapi",
        path: `/food-journals/${patientUserId}`,
        options: {
          headers: {
            Authorization: session.tokens.idToken.toString(),
          },
          body: formInputs,
        },
      }).response;
      return await body.json();
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [FOOD_JOURNAL_LATEST_QUERY_KEY, patientUserId],
      });
    },
  });
};

export const useFoodJournalPutMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (formInputs) => {
      const session = await fetchAuthSession();
      const { body } = await put({
        apiName: "hifoodjournalapi",
        path: "/food-journals",
        options: {
          headers: {
            Authorization: session.tokens.idToken.toString(),
          },
          body: formInputs,
        },
      }).response;
      return await body.json();
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [FOOD_JOURNAL_QUERY_KEY],
      });
    },
  });
};

export const useFoodJournalDeleteMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (id) => {
      const session = await fetchAuthSession();
      const { body } = await del({
        apiName: "hifoodjournalapi",
        path: `/${id}`,
        options: {
          headers: {
            Authorization: session.tokens.idToken.toString(),
          },
        },
      }).response;
      return await body.json();
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [FOOD_JOURNAL_LATEST_QUERY_KEY],
      });
    },
  });
};
